import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { commonActions, inboxActions } from '../../../../../store/actions'
import moment from 'moment'
import { commons } from '../../../../../hook/common'

/*
   간접수출실적증명서 form
 */
const InboxFormNew2 = (props) => {
  const [state, setState] = useState({})
  const [commoncode, setCommoncode] = useState({})

  useEffect(() => {
    props.getCommonCode({ mainCd: ['CRT_FORM_TP', 'CRT_PERFORM_TP', 'CRT_SUBMIS_TP'] })
  }, [])

  useEffect(() => {
    setCommoncode({
      ...commoncode,
      ...props.commoncode,
    })

    setState({
      ...state,
      docFormatNm: props.commoncode?.CRT_FORM_TP?.find((co) => co.cd === props.data?.docFormat)?.cdName,
      docTypeNm: props.commoncode?.CRT_SUBMIS_TP?.find((co) => co.cd === props.data?.submisType)?.cdName,
      submissionNm: props.commoncode?.CRT_SUBMIS_TP?.find((co) => co.cd === props.data?.submission)?.cdName,
    })
  }, [props.commoncode])

  return (
    <>
      <h3 className="h3-tit first">일반정보</h3>
      <table className="tbl-view">
        <caption>서식유형, 제출처분류, 제출처, 용도, 상호 / 사업자명, 대표자명, 주소, 업종 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">서식유형</th>
            <td>{props.data?.docFormat}</td>
          </tr>
          <tr>
            <th scope="row">제출처분류</th>
            <td>
                  {
                    props.data?.submisType === 'FRM001'?
                      '무역보험공사서식' :
                      (props.data?.submisType === 'FRM002'? '무역의날포상서식' : 
                        (props.data?.submisType === 'FRM003'? '대외무역법정서식' : '')
                      )                    
                  }
            </td>
          </tr>
          <tr>
            <th scope="row">제출처</th>
            <td>{props.data?.submission}</td>
          </tr>
          <tr>
            <th scope="row">용도</th>
            <td>{props.data?.purpose}</td>
          </tr>
          <tr>
            <th scope="row">상호 / 사업자명</th>
            <td>
              {props.data?.orgNm} | {props.data?.orgId}
            </td>
          </tr>
          <tr>
            <th scope="row">대표자명</th>
            <td>{props.data?.orgCeoNm}</td>
          </tr>
          <tr>
            <th scope="row">주소</th>
            <td>
              ({props.data?.orgZipCd})<br /> {props.data?.orgAddress}
            </td>
          </tr>
          <tr>
            <th scope="row">업종</th>
            <td>{props.data?.sector}</td>
          </tr>
        </tbody>
      </table>
      <div className="pc-only">
        <div className="tbl-wrap mt20">
          <table className="tbl-list">
            <caption>번호, 구분, 품목명, 확인(입금)일자, 발급(메인)번호, 실적금액(원화), 실적금액(USD), 비고 항목으로 구성</caption>
            <colgroup>
              <col style={{ width: '12.5%' }} />
              <col style={{ width: '12.5%' }} />
              <col style={{ width: '12.5%' }} />
              <col style={{ width: '12.5%' }} />
              <col style={{ width: '12.5%' }} />
              <col style={{ width: '12.5%' }} />
              <col style={{ width: '12.5%' }} />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">번호</th>
                <th scope="col">구분</th>
                <th scope="col">품목명</th>
                <th scope="col">확인(입금)일자</th>
                <th scope="col">발급(메인)번호</th>
                <th scope="col">실적금액(원화)</th>
                <th scope="col">실적금액(USD)</th>
                <th scope="col">비고</th>
              </tr>
            </thead>
            <tbody>
              {props.data?.performList?.length > 0 ? (
                props.data?.performList.map((perform, index) => (
                  <tr key={index}>
                    <td data-title="번호">{perform.crtCrtfSeq}</td>
                    <td data-title="구분">
                      {perform.performtype === '01' ? '구매확인서' : perform.performtype === '02' ? '내국신용장' : '은행'}
                    </td>
                    <td data-title="품목명">{perform.itemnm}</td>
                    <td data-title="확인(입금)일자">{perform.confirmdt && moment(perform.confirmdt, 'YYYYMMDD').format('YYYY.MM.DD')}</td>
                    <td data-title="발급(메인)번호">{perform.purchasenum}</td>
                    <td data-title="실적금액(원화)">{perform.performAmtKrw && commons.addComma(perform.performAmtKrw)}</td>
                    <td data-title="실적금액(USD)">{perform.performAmtUsd && commons.addComma(perform.performAmtUsd)}</td>
                    <td data-title="비고">{perform.remark}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="center" colSpan={8}>
                    <div className="nodata">조회 결과가 없습니다.</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="mobile-only">
        <h3 className="h3-tit">실적 정보</h3>
        <table className="tbl-view">
          <caption>번호, 구분, 품목명, 확인(입금)일자, 발급(메인)번호, 실적금액(원화), 실적금액(USD), 비고 항목으로 구성</caption>
          <colgroup>
            <col className="col1" />
            <col />
          </colgroup>
          <tbody>
            {props.data?.performList?.length > 0 ? (
              props.data?.performList.map((perform, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <th scope="row" data-title="번호">
                      번호
                    </th>
                    <td>{perform.crtCrtfSeq}</td>
                  </tr>
                  <tr>
                    <th scope="row" data-title="구분">
                      구분
                    </th>
                    <td>{perform.performtype === '01' ? '구매확인서' : perform.performtype === '02' ? '내국신용장' : '은행'}</td>
                  </tr>
                  <tr>
                    <th scope="row" data-title="품목명">
                      품목명
                    </th>
                    <td>{perform.itemnm}</td>
                  </tr>
                  <tr>
                    <th scope="row" data-title="확인(입금)일자">
                      확인(입금)일자
                    </th>
                    <td>{perform.confirmdt && moment(perform.confirmdt, 'YYYYMMDD').format('YYYY.MM.DD')}</td>
                  </tr>
                  <tr>
                    <th scope="row" data-title="발급(메인)번호">
                      발급(메인)번호
                    </th>
                    <td>{perform.purchasenum}</td>
                  </tr>
                  <tr>
                    <th scope="row" data-title="실적금액(원화)">
                      실적금액(원화)
                    </th>
                    <td>{perform.performAmtKrw && commons.addComma(perform.performAmtKrw)}</td>
                  </tr>
                  <tr>
                    <th scope="row" data-title="실적금액(USD)">
                      실적금액(USD)
                    </th>
                    <td>{perform.performAmtUsd && commons.addComma(perform.performAmtUsd)}</td>
                  </tr>
                  <tr>
                    <th scope="row" data-title="비고">
                      비고
                    </th>
                    <td>{perform.remark}</td>
                  </tr>
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td className="center" colSpan={2}>
                  <div className="nodata">조회 결과가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {props.data?.attachGroupId && (
        <div>
          <h3 className="h3-tit">첨부파일</h3>
          <table className="tbl-view">
            <caption>파일다운로드 항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              {props.data?.attachList?.length > 0 ? (
                props.data?.attachList.map((attach, index) => (
                  <tr key={index}>
                    <td colSpan={2}>
                      <a href={'/portal/file/' + attach?.fileId} download title="파일다운로드">
                        {attach.originFileNm}
                      </a>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="center" colSpan={2}>
                    <div className="nodata">조회 결과가 없습니다.</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      <h3 className="h3-tit">발급이력</h3>
      <table className="tbl-view">
        <caption>발급일자 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">발급일자</th>
            <td>{props.data?.issuedt && moment(props.data?.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD')}</td>
          </tr>
        </tbody>
      </table>
      <div className="btn-block">
        <span className="right">
          <a href="#" className="btn-primary md" onClick={props.onPDFView}>
            PDF
          </a>
          <a href="#" className="btn-secondary md" onClick={props.goList}>
            목록
          </a>
        </span>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    commoncode: state.commoncode?.co,
  }
}

const actionCreators = {
  getCommonCode: commonActions.getCommonCode,
  getFile: inboxActions.getFile,
}

export default connect(mapStateToProps, actionCreators)(InboxFormNew2)
